import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Input, Select, Spin } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";
import { format } from "date-fns";
import { Calendar } from "react-date-range";

type Permission = { id: number; name: string };
type Admin = {
  id: number;
  branch_name: string;
  is_wizklub: boolean;
  is_offline: boolean;
  branch: number;
};

type Agent = {
  id: number;
  username: string;
};

type Trainer = {
  id: number;
  username: string;
}

type State = {
  state_id: number,
  name: string,
  label: string,
}
type Zone = {
  zone_id: number,
  name: string,
  label: string,
}

type Branch = {
  branch_id: number,
  name: string,
  label: string,
}

type SortOrder = 'ascend' | 'descend' | null;

interface SortConfig {
  field: string;
  order: SortOrder;
}

const { Option } = Select;


const WizklubStudentSessions = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("wizlubParentStudentOrientationsCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("wizlubParentStudentOrientationsCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
  const [pageSize, setPageSize] = useState<number>(() => {
    const savedPageSize = localStorage.getItem("wizlubParentStudentOrientationsPageSize");
    return savedPageSize ? Number(savedPageSize) : 10;
  });

  useEffect(() => {
    localStorage.setItem("wizlubParentStudentOrientationsPageSize", pageSize.toString());
  }, [pageSize]);
  const [searchText, setSearchText] = useState<string>(() => {
    return localStorage.getItem("wizlubParentStudentOrientationsSearchText") || "";
  });

  useEffect(() => {
    localStorage.setItem(
      "wizlubParentStudentOrientationsSearchText",
      searchText
    );
  }, [searchText]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [trainerDropdown, setTrainerDropdown] = useState<Trainer[]>([]);
  const [assignmentType, setAssignmentType] = useState<'agent' | 'trainer' | undefined>();
  const [dangerToastMessage, setDangerToastMessage] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [states, setStates] = useState<State[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [selectedState, setSelectedState] = useState<number>(0);
  const [selectedZone, setSelectedZone] = useState<number>(0);
  const [selectedBranch, setSelectedBranch] = useState<number>(0);
  const [selectedTrainer, setSelectedTrainer] = useState<number>(0);
  const [selectedAgentFilter, setSelectedAgentFilter] = useState<number>(0);
  const [unAssignLoading, setUnAssignLoading] = useState(false);
  const handleClearState = () => setSelectedState(0);
  const handleClearZone = () => setSelectedZone(0);
  const handleClearBranch = () => setSelectedBranch(0);
  const handleClearTrainer = () => setSelectedTrainer(0);
  const handleClearAgent = () => setSelectedAgentFilter(0);
  const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);
  const [nameSearchText, setNameText] = useState("");
  const [totalStudentsText, setTotalStudentsText] = useState("");
  const [showCalendar1, setShowCalendar1] = useState(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const [selectedDate, setSelectedDate] = useState(() => {
    const savedDate = localStorage.getItem("sessionDate");
    return savedDate ? new Date(savedDate) : null; // default empty
  });
  const [selectedIsSale, setSelectedIsSale] = useState<boolean | null>(() => {
    const stored = localStorage.getItem("wizklubStudentSessionSelectedIsSale");

    if (stored === null) return null;
    return stored === "true";
  });

  useEffect(() => {
    if (selectedIsSale === null) {
      localStorage.removeItem("wizklubStudentSessionSelectedIsSale");
    } else {
      localStorage.setItem(
        "wizklubStudentSessionSelectedIsSale",
        String(selectedIsSale)
      );
    }
  }, [selectedIsSale]);

  const handleClearIsSale = () => {
    setSelectedIsSale(null);
  };

  useEffect(() => {
    if (selectedDate) {
      const formatted = format(selectedDate, "yyyy-MM-dd");
      localStorage.setItem("sessionDate", formatted);
      setShowCalendar1(false);
    } else {
      localStorage.removeItem("sessionDate");
    }
  }, [selectedDate]);

  useEffect(() => {
    if (!checkPermission("view_wizklubsessionstudent", "wizklubsessionstudent")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer);
      fetchAgentsData();
      fetchTrainerData();
      fetchStates();
      fetchZones();
      fetchBranches(selectedState, selectedZone);
    }
  }, [userPermissions]);

  useEffect(() => {
    fetchZones();
    fetchBranches(selectedState, selectedZone);
  }, [selectedState, selectedZone])

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const handleAgentUnAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setUnAssignLoading(true);
    try {
      const response = await fetch(
        `${webApi}/branches/unassign_wizklub_agents_from_branches/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            branch_ids: selectedRowKeys,
            // agent_id: selectedAgent,
            // target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        // setDangerToastMessage(data.message);
        // setShowSolidDangerToast(true);
        // throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setSelectedRowKeys([]);
      setSelectedAgent([]);
      // setTargetDate("");
      fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer);
      setAsignShowCard(false);
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setUnAssignLoading(false);
      // fetchData(currentPage, pageSize, searchText);
    }
  };

  const fetchAgentsData = async () => {
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const fetchTrainerData = async () => {
    try {
      const response = await fetch(
        `${webApi}/wizklub/wizklub_trainers_dropdown/`,
        options
      );
      const data = await response.json();
      setTrainerDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await fetch(
        `${webApi}/branches/branches_state_dropdown/`,
        options
      );
      const data = await response.json();
      setStates(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchZones = async () => {
    try {
      const response = await fetch(
        `${webApi}/branches/branches_zone_dropdown/${selectedState}/`,
        options
      );
      const data = await response.json();
      setZones(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchBranches = async (state: any, zone: any) => {
    try {
      let url = `${webApi}/wizklub_parents_sessions/wizklub_braches_dropdown_for_session_filters/`;

      // Manually build query parameters
      let queryParams = [];

      if (state && state !== 0) {
        queryParams.push(`state_id=${state}`);
      }

      if (zone && zone !== 0) {
        queryParams.push(`zone_id=${zone}`);
      }

      if (queryParams.length > 0) {
        url += "?" + queryParams.join("&");
      }

      const response = await fetch(url, options);
      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error("Failed to fetch branches", error);
    }
  };



  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    state: number,
    zone: number,
    branch: number,
    agent: number,
    trainer: number,

  ) => {
    let apiUrl = `${webApi}/wizklub_parents_sessions/wizklub_sessions_student/?page=${page}&page_size=${pageSize}`
    if (searchText) apiUrl += `&search=${searchText}`;
    if (branch) apiUrl += `&branch=${branch}`;
    if (nameSearchText) apiUrl += `&teacher_name__icontains=${nameSearchText}`;
    if (totalStudentsText) apiUrl += `&total_students=${totalStudentsText}`;
    if (selectedDate) apiUrl += `&scheduled_date=${format(selectedDate, "yyyy-MM-dd")}`;
    if (selectedIsSale !== null) {
      apiUrl += `&is_sale=${selectedIsSale}`;
    }
    if (sortConfigs.length > 0) {
      const orderingParams = sortConfigs
        .map(({ field, order }) =>
          order === 'descend' ? `-${field}` : field
        )
        .join(',');
      apiUrl += `&ordering=${orderingParams}`;
    }
    const response = await fetch(
      apiUrl,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    state: number,
    zone: number,
    branch: number,
    agent: number,
    trainer: number,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText, state, zone, branch, agent, trainer),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setTotalCount(groupsData.total_count);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    // fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // fetchData(currentPage, pageSize, value);
  };

  const updateBranchDetails = async (
    id: any,
    updateData: { [x: number]: any }
  ) => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(updateData),
    };
    const url = `${webApi}/branches/branch_details/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error("Network response was not ok");
    }
  };

  const handleCheckboxChange = async (
    id: any,
    field: string,
    value: boolean
  ) => {
    const updateData = { [field]: value };
    try {
      await updateBranchDetails(id, updateData);
      // await fetchData(currentPage, pageSize, searchText);
    } catch (error) {
      console.error("Error updating branch details:", error);
    }
  };

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const endpoint = assignmentType === 'agent'
        ? `${webApi}/branches/assign_wizklub_agents_to_branches/`
        : `${webApi}/branches/assign_wizklub_trainers_to_branches/`;
      const response = await fetch(
        endpoint,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            branch_ids: selectedRowKeys,
            leader_id: selectedAgent,
            // target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setDangerToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent([]);
      // setTargetDate("");
      setAsignShowCard(false);
      fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer)
      setAssignmentType(undefined);
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleSelectChange = (value: string[]) => {
    setSelectedAgent(value);
  };

  const handleExportClick = () => {
    let apiUrl = `${webApi}/wizklub_parents_sessions/export_wizklub_sessions_student/?token=${jwtToken}`;
    if (searchText) apiUrl += `&search=${searchText}`;
    if (selectedBranch) apiUrl += `&branch=${selectedBranch}`;
    if (nameSearchText) apiUrl += `&teacher_name__icontains=${nameSearchText}`;
    if (totalStudentsText) apiUrl += `&total_students=${totalStudentsText}`;
    if (selectedDate) apiUrl += `&scheduled_date=${format(selectedDate, "yyyy-MM-dd")}`;
    if (selectedIsSale !== null) {
      apiUrl += `&is_sale=${selectedIsSale}`;
    }
    window.location.href = apiUrl;
  };

  useEffect(() => { fetchData(currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer) }, [currentPage, pageSize, searchText, selectedState, selectedZone, selectedBranch, selectedAgentFilter, selectedTrainer, nameSearchText, totalStudentsText, sortConfigs, selectedDate, selectedIsSale]);

  const columns = [
    {
      title: (
        <span>
          Branch{selectedBranch !== 0 ? ` (${branches.find(branch => branch.branch_id === selectedBranch)?.name})` : ""}
          {selectedBranch !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearBranch}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "branch",
      key: "branch",

      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = branches.find((b) => b.branch_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedBranch(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {branches.map((branch) => (
              <Select.Option key={branch.branch_id} value={branch.branch_id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
    },
    {
      title: (
        <span>
          SCS Number
          <span>
            {sortConfigs.some(config => config.field === "name") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "name")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}
            {nameSearchText && (
              <span
                style={{
                  marginLeft: 8,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#1890ff", marginRight: 4 }}>
                  ({nameSearchText})
                </span>
                <CloseCircleOutlined
                  onClick={() => {
                    setNameText("");
                  }}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </span>
            )}
          </span>
        </span>
      ),
      dataIndex: "scs_number",
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }: FilterDropdownProps) => (
      //   <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      //     <Input
      //       placeholder="Search SCS Number"
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => {
      //         confirm();
      //         setNameText(selectedKeys[0] as string);
      //       }}
      //       style={{ marginBottom: 8, display: "block" }}
      //     />
      //   </div>
      // ),
      // filterIcon: (filtered: boolean) => (
      //   <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      // ),
    },
    {
      title: (
        <span>
          Name
          <span>
            {sortConfigs.some(config => config.field === "name") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "name")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}
            {totalStudentsText && (
              <span
                style={{
                  marginLeft: 8,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#1890ff", marginRight: 4 }}>
                  ({totalStudentsText})
                </span>
                <CloseCircleOutlined
                  onClick={() => {
                    setTotalStudentsText("");
                  }}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </span>
            )}
          </span>
        </span>
      ),
      dataIndex: "student",
      // filterDropdown: ({
      //   setSelectedKeys,
      //   selectedKeys,
      //   confirm,
      //   clearFilters,
      // }: FilterDropdownProps) => (
      //   <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      //     <Input
      //       placeholder="Search Count"
      //       value={selectedKeys[0]}
      //       onChange={(e) =>
      //         setSelectedKeys(e.target.value ? [e.target.value] : [])
      //       }
      //       onPressEnter={() => {
      //         confirm();
      //         setTotalStudentsText(selectedKeys[0] as string);
      //       }}
      //       style={{ marginBottom: 8, display: "block" }}
      //     />
      //   </div>
      // ),
      // filterIcon: (filtered: boolean) => (
      //   <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      // ),
    },
    {
      title: (
        <span>
          Is Sale
          {selectedIsSale !== null && (
            <>
              {`${selectedIsSale ? ' (Yes)' : ' (No)'}`}
              <CloseCircleOutlined
                onClick={handleClearIsSale}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            </>
          )}
        </span>
      ),
      dataIndex: "is_sale",
      key: "is_sale",
      render: (value: boolean) => (value ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder=" Is Sale"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              setSelectedKeys([value]);
              setSelectedIsSale(value); // <-- Updated state handler
              confirm();
            }}
            allowClear
          >
            <Select.Option value={true}>Yes</Select.Option>
            <Select.Option value={false}>No</Select.Option>
          </Select>
        </div>
      ),
    },

  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Wizklub Student Sessions</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Wizklub Student Sessions
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {checkPermission("export_wizklubsessionstudent", "wizklubsessionstudent") && (
                <button className="btn btn-primary me-2" onClick={handleExportClick} >
                  Export
                </button>
              )}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Wizklub Student Sessions</h4>

            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>

      {AsignshowCard && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1049,
            }}
          />
          <div
            className="card"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "20%",
              boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
              borderRadius: "10px",
              zIndex: 1050,
              backgroundColor: "#f9f9f9",
              padding: "20px",
            }}
          >
            <form onSubmit={handleAgentAssignment}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    {/* Assignment type dropdown */}
                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{
                          paddingBottom: "10px",
                          fontWeight: "bold",
                          color: "#555",
                        }}
                      >
                        Assignment Type
                      </label>
                      <Select
                        placeholder="Select Assignment Type"
                        value={assignmentType}
                        onChange={(value) => {
                          setAssignmentType(value);

                        }}
                        style={{ width: "100%" }}
                      >
                        <Option value="agent">Assign Agent</Option>
                        <Option value="trainer">Assign Trainer</Option>
                      </Select>
                    </div>

                    {/* Conditional dropdown based on assignment type */}
                    {assignmentType && (
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          {assignmentType === 'agent' ? 'Select Agent' : 'Select Trainer'}
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            placeholder={`Select ${assignmentType === 'agent' ? 'Agent' : 'Trainer'}`}
                            value={selectedAgent}
                            onChange={handleSelectChange}
                            style={{ width: "100%" }}
                            showSearch
                            filterOption={(input, option) => {
                              if (!option || !option.children) return false;
                              const label = option.children as unknown as string;
                              return label.toLowerCase().includes(input.toLowerCase());
                            }}
                          >
                            {assignmentType === 'agent'
                              ? agentsDropdown.map((agent) => (
                                <Option key={agent.id} value={agent.id}>
                                  {agent.username}
                                </Option>
                              ))
                              : trainerDropdown.map((trainer) => (
                                <Option key={trainer.id} value={trainer.id}>
                                  {trainer.username}
                                </Option>
                              ))
                            }
                          </Select>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-light me-2"
                  onClick={() => {
                    setAsignShowCard(false);
                    setAssignmentType(undefined); // Reset to default
                    // setSelectedAgent(undefined);
                  }}
                >
                  Cancel
                </Button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={agentsLoading || !assignmentType || !selectedAgent}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </>
      )}
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default WizklubStudentSessions;
